// Centralized tier configuration for frontend
// Kajabi/Stripe checkout URLs must be configured per tier (Oscar)
export const TIER_CONFIG = {
  tier1: {
    id: 'tier1',
    name: 'Tier 1',
    yearly: 12000,
    upgradePrice: 0,
    monthly: 0,
    maxPerTrade: 500,
    description: 'Up to $500 risk per trade. The standard QFAA Tier included with every plan.',
    features: [
      'Up to $500 risk per trade',
      'Full Quantum Flo Auto Algo engine',
      'Trades SPY & QQQ (SPX when available)',
    ],
    checkoutUrl: import.meta.env.VITE_KAJABI_CHECKOUT_TIER1 || '',
  },
  tier2: {
    id: 'tier2',
    name: 'Tier 2',
    yearly: 19900,
    upgradePrice: 7900,
    monthly: 0,
    maxPerTrade: 1000,
    description: 'Raises your cap to $1,000 risk per trade',
    features: [
      'Up to $1,000 risk per trade',
      'Everything in Tier 1',
      'Larger position sizing on every signal',
    ],
    checkoutUrl: import.meta.env.VITE_KAJABI_CHECKOUT_TIER2 || '',
  },
  tier3: {
    id: 'tier3',
    name: 'Tier 3',
    yearly: 31000,
    upgradePrice: 19000,
    monthly: 0,
    maxPerTrade: 2000,
    description: 'Raises your cap to $2,000 risk per trade',
    features: [
      'Up to $2,000 risk per trade',
      'Everything in Tier 2',
      'Maximum position sizing on every signal',
    ],
    checkoutUrl: import.meta.env.VITE_KAJABI_CHECKOUT_TIER3 || '',
  },
};

export const getTierConfig = (tierId) => TIER_CONFIG[tierId] || TIER_CONFIG.tier1;

export const getTierOrder = (tierId) => {
  const order = { tier1: 1, tier2: 2, tier3: 3 };
  return order[tierId] || 1;
};

export const canUpgrade = (currentTier, targetTier) =>
  getTierOrder(targetTier) > getTierOrder(currentTier);

export const formatTierPrice = (price) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(price);
